import classNames from "classnames";
import {
  CALL_CONNECTED,
  CALL_DISCONNECTED,
  CALL_NO_RESPONSE,
} from "constants/CallAdmin";
import {
  TICKET_CREATED,
  TICKET_RESOLVED,
  TICKET_PAYMENT,
  TICKET_UPDATED,
  TICKET_PAID,
} from "constants/ticket";
import { ReactNode } from "react";

export type TicketStatusType =
  | "IN_PROGRESS"
  | "COMPLETED"
  | typeof TICKET_CREATED
  | typeof TICKET_RESOLVED
  | typeof TICKET_PAYMENT
  | typeof TICKET_UPDATED
  | typeof TICKET_PAID
  | typeof CALL_NO_RESPONSE
  | typeof CALL_CONNECTED
  | typeof CALL_DISCONNECTED;

const Header = ({
  icon,
  children,
}: {
  icon?: ReactNode;
  children: ReactNode;
}) => (
  <div className="t-border-neutral-0 t-border-b t-border-solid t-w-full t-flex t-items-center t-justify-between t-p-3 t-gap-1.5 t-border-0 t-bg-neutral-0 t-rounded-t">
    {icon && icon}
    <span className="t-text-subtext-sm t-text-text-100 t-w-full">
      {children}
    </span>
  </div>
);

const Content = ({
  addMargin = true,
  children,
}: {
  addMargin?: boolean;
  children: ReactNode;
}) => (
  <div
    className={classNames(
      "t-bg-surface t-border t-border-neutral-10 t-border-solid t-rounded-lg t-max-w-[360px] t-min-w-[200px]",
      {
        "t-mt-1.5 t-mx-1": addMargin,
      }
    )}
  >
    {children}
  </div>
);

const Body = ({ children }: { children: ReactNode }) => (
  <div className="t-p-3">{children}</div>
);

const ChatCard = { Header, Content, Body };

export default ChatCard;
